<template>
<div id="ag-grid-demo">
    <vx-card>

        <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 h-50 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="rowData" :floatingFilter="true" @grid-ready="onGridReady" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" :frameworkComponents="frameworkComponents">
        </ag-grid-vue>
        <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
    </vx-card>
</div>
</template>

<script>
import {
    AgGridVue
} from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import {
    Datepicker
} from "../components/Datepicker.vue";

export default {
    components: {
        AgGridVue
    },
    data() {
        return {
            frameworkComponents: {
                agDateInput: Datepicker
            },
            gridOptions: {
                enableBrowserTooltips: true,
                onFilterChanged: this.onGridReady,
                rowModelType: 'infinite',
                onRowDoubleClicked: this.navigate,
                rowSelection: "single",
                floatingFiltersHeight: 40,
                rowStyle: {
                    'text-align': 'center',
                    'cursor': 'pointer'
                }
            },
            maxPageNumbers: 5,
            gridApi: null,
            defaultColDef: {

                sortable: false,
                resizable: true,
                filter: true,
                suppressMenu: true,

                floatingFilterComponentParams: {
                    suppressFilterButton: true
                },
                filterParams: {
                    newRowsAction: 'keep',

                }

            },
            columnDefs: [{
                    headerName: 'Doctor Name',
                    field: 'doctorName',
                    filter: true,
                    width: 178,
                    cellStyle: {
                        'text-align': 'left'
                    },
                    tooltipValueGetter: (params) => {

                        return 'Double click to register OP'
                    }

                },
                {
                    headerName: 'Appointment Date ',
                    field: 'appointmentDate',
                    filter: 'agDateColumnFilter',
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filterParams: {
                        newRowsAction: 'keep',
                        // browserDatePicker: true
                    },
                    width: 165,
                    tooltipValueGetter: (params) => {

                        return 'Double click to register OP'
                    }
                },
                {
                    headerName: 'Appointment Time',
                    field: 'appointmentTime',
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filter: true,
                    width: 141,
                    tooltipValueGetter: (params) => {

                        return 'Double click to register OP'
                    }
                },
                {
                    headerName: 'TokenNo',
                    field: 'tokenNo',
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filter: true,
                    width: 77,
                    tooltipValueGetter: (params) => {

                        return 'Double click to register OP'
                    }
                },
                {
                    headerName: 'PhoneNo',
                    field: 'phoneNo',
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filter: true,
                    width: 96,
                    tooltipValueGetter: (params) => {

                        return 'Double click to register OP'
                    }

                },
                {
                    headerName: 'Status',
                    field: 'status',
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filter: true,
                    width:79,
                    cellStyle: function (params) {
                        if (params.value == 'OP') {
                            return {
                                color: 'red'
                            };
                        } else {
                            return {
                                color: 'green'
                            };
                        }
                    },
                    tooltipValueGetter: (params) => {

                        return 'Double click to register OP'
                    }
                },
                {
                    headerName: 'Id',
                    field: 'bookingid',
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filter: true,
                    width: 105,
                    tooltipValueGetter: (params) => {

                        return 'Double click to register OP'
                    }
                },
                {
                    headerName: 'Entry Time',
                    field: 'entryTime',
                    cellStyle: {
                        'text-align': 'center'
                    },
                    filter: 'agDateColumnFilter',
                    filterParams: {
                        newRowsAction: 'keep',
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            var dateAsString = cellValue;
                            var dateParts = dateAsString.split("/");
                            var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        }
                    },
                    width: 163,
                    tooltipValueGetter: (params) => {

                        return 'Double click to register OP'
                    }
                }
            ],
            rowData: null,
        }
    },

    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 8
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
                this.onGridReady();
            }
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridApi.sizeColumnsToFit();
    },

    methods: {

        onGridReady(params) {
            this.gridApi.showLoadingOverlay();
            window.addEventListener("resize", function () {
                setTimeout(function () {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
            var request = {
                companyId: this.$session.get('companyId'),
                currentPage: this.gridApi.paginationGetCurrentPage() + 1,
                limit: this.gridApi.paginationGetPageSize(),
                filter: this.gridApi.getFilterModel()
            }
            var datasource = {
                getRows: (params) => {
                    this.$http.post(
                        "v2/getQuickopTokenDashboard",
                        JSON.stringify(request), {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }).then(response => {
                        params.successCallback(response.data.data, response.data.recordsTotal);
                        this.gridApi.hideOverlay();

                    });

                }
            }
            this.gridApi.setDatasource(datasource);
        },
        mobileNoValidate(contactNumber) {
           contactNumber = contactNumber.replace("+91", "");
           return contactNumber;
        },
        navigate() {
            var selectedrow = this.gridApi.getSelectedRows();
            var selectedPhoneNo = "";
            var selectedStatus = "";
            var selectedTokenId = "";
            selectedrow.forEach((value) => {
                selectedPhoneNo = value.phoneNo;
                selectedPhoneNo = this.mobileNoValidate(selectedPhoneNo)
            
                selectedStatus = value.status;
                selectedTokenId = value.tokenId;
            })

            if (selectedStatus != 'OP') {
                 this.$router.push({
                            path: "QuickOp",
                            query: {
                                tokenId: selectedTokenId,
                               
                            }
                        });
               
                    
            }

        }
    }
}
</script>

<style>
.ag-header-cell-label {
    justify-content: center;
}
</style>
